import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import EPIFormQuestion from "./EPIFormQuestion";
import { throwErrorMessage } from "../../lib/error_helper";
import { getCurrentFunctionName } from "../../performanceModeManager";
import './EPIFormSection.css'
import { saveQuestions } from "../../redux/humanResources/humanResourcesEditionActions";
import Typography from "@mui/material/Typography";

const styles = (theme) => ({
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: "33.33%",
        flexShrink: 0,
    },
    italic: {
        fontSize: theme.typography.pxToRem(13),
        flexBasis: "33.33%",
        flexShrink: 0,
        fontStyle: "italic",
        paddingTop: 0,
    },
    AccordionSummaryContent: {
        content: {
            margin: 3,
        },
    },
});

class EPIFormSection extends Component {
    constructor(props) {
        super(props);
    }

    responseValueChange(metaQuestion) {
        let sectionId = this.props.currentSectionId;
        this.props.responseValueChange(sectionId, metaQuestion);

        this.forceUpdate();
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        const { classes } = this.props;
        let questionsElements = [];
        let section = this.props.sections.find(
            (bv) => bv.id === this.props.currentSectionId
        );

        section.questions
            .sort((mq) => mq.sequence)
            .forEach((metaQuestion) => {
                let required = metaQuestion.is_require_answer;

                let index = metaQuestion.id;

                questionsElements.push(
                    <EPIFormQuestion
                        key={index}
                        id={[this.props.id.toString(), index].join("-")}
                        responseValueChange={this.responseValueChange.bind(this)}
                        metaQuestion={metaQuestion}
                        sectionId={section.id}
                        form={this.props.form}
                        required={required}
                        section={section}
                    />
                );
            });

        return (
            <div
                className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
                ref={(panel) => (this.panel = panel)}
            >
                <Typography className={classes.heading} variant="h5">
                    {section.title}
                </Typography>
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 row">
                    {questionsElements}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sections: state.equipmentEPI.equipmentEPIFormSections,
        form: state.equipmentEPI.currentEquipmentEPIForm,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        throwErrorMessage: (errorObject) => dispatch(throwErrorMessage(errorObject)),
        saveQuestions: (form, sections, questions, user) => dispatch(saveQuestions(form, sections, questions, user)),
    };
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(EPIFormSection);
